/**
 * @author yangxiaochuan
 * 工作流定制表
 */
import Component from "../../../lib/component";
import template from './workflow-page.html';
import './workflow-page.scss';
import '../../../assets/scss/dataGrid/dataGrid-icon.scss';
import {HTTP} from "../../../lib/http";
import msgBox from '../../../lib/msgbox';
import Mediator from '../../../lib/mediator';
import {PMAPI,PMENUM} from '../../../lib/postmsg';
import agGrid from '../../../components/dataGrid/agGrid/agGrid';
import {wchService} from '../../../services/dataGrid/workflow-config-header.service';
import {dgcService} from "../../../services/dataGrid/data-table-control.service";
import {dataTableService} from '../../../services/dataGrid/data-table.service';
import {workflowService} from "../../../services/workflow/workflow.service";
import dataPagination from "../../dataGrid/data-table-toolbar/data-pagination/data-pagination";
import FloatingFilter from "../../dataGrid/data-table-toolbar/floating-filter/floating-filter";
import customColumns from "../../dataGrid/data-table-toolbar/custom-columns/custom-columns";
import ProjectManager from '../project-manager/ProjectManager.jsx';
import InvestmentAdvisor from '../investment-advisor/InvestmentAdvisor.jsx';
import erdsDialog from '../../../lib/editableDialog';
import reactDialog from '../../../lib/editableDialog';



let workflowPage = Component.extend({
    template: template,
    data: {
        tableId: '',
        folderId: '',
        columnDefs: [],
        rowData:[],
        footerData:[],
        fieldsData:[],
        permission:{},
        circulate_users:[],
        //权限
        permission2btn: {
            add: '',
            calendar: '',
            complex_search: 'expert-search-btn',
            custom_field: 'custom-column-btn',
            custom_width: 'grid-auto-width',
            delete: '',
            new_window: 'grid-new-window',
            cancel: 'batch-cancel',
            download: '',
            edit: '',
            group: '',
            in_work: '',
            search: 'float-search-btn',
            upload: '',
            view: '',
            setting: '',
            cell_edit: '',
            table_BI: '',
            common: 'common-use',
        },
        rows: 100,
        total: 0,
        page: 1,
        //pageType{0:'进展中的工作',1:'已完成的工作',2:'我的工作申请中的工作',3:'我的工作已完成的工作',4:'我的工作审批过的工作',5:'工作审批',6:'我的工作已关注的工作'}
        pageType: 5,
        // tableId2pageType: {'approve-workflow':5,'approving-workflow':0,'finished-workflow':1,'my-workflow':2,'finish-workflow':3,'focus-workflow':6,'approved-workflow':4},
        // tableId2Name: {'approve-workflow':'工作审批','approving-workflow':'进展中的工作','finished-workflow':'已完成的工作','my-workflow':'我的工作->申请中的工作','finish-workflow':'我的工作->已完成的工作','focus-workflow':'我的工作->已关注的工作','approved-workflow':'我的工作->审批过的工作'},
        tableId2pageType: {'approve-workflow':5,'suspend-workflow':7,'approving-workflow':0,'finished-workflow':1,'my-workflow':2,'finish-workflow':3,'focus-workflow':6,'approved-workflow':4,'sponsor-flow':8,'my-sponsor':8,'my-correlation':9},
        tableId2Name: {'approve-workflow':'工作审批','sponsor-flow':'我发起的流程','suspend-workflow':'暂缓审批的工作','approving-workflow':'进展中的工作','finished-workflow':'已完成的工作','my-workflow':'我的工作->申请中的工作','finish-workflow':'我的工作->已完成的工作','focus-workflow':'我的工作->已关注的工作','approved-workflow':'我的工作->审批过的工作','my-sponsor':'我的工作-我发起的工作','my-correlation':'与我相关'},
        //定制列（列宽）
        colWidth: {},
        //定制列（固定列）
        fixCols: {l: [], r: []},
        //定制列（列排序）
        orderFields: [],
        //定制列（隐藏列）
        ignoreFields: [],
        //请求数据参数
        commonQueryData:[],
        onlyCloseExpertSearch:false,
        //是否第一次渲染agGrid
        firstRender: true,
        //可以搜索的数据
        iCanSearch: {},
        //搜索参数
        filterParam: {expertFilter:[], filter: [], is_filter: 0, common_filter_id: '', common_filter_name: ''},
        //floatingFilter搜索参数
        searchValue: [],
        //floatingFilter搜索参数
        searchOldValue: [],
        //floatingFilter搜索参数
        queryList: {},
        //搜索参数(判断是否需要重置分页)
        filterText: '',
        //临时查询数据
        temporaryCommonQuery:[],
        //选择的数据
        selectRows: [],
        //高级查询字段参数
        expertSearchFields:[],
        //是否显示floatingfilter
        isShowFloatingFilter: false,
        //排序参数
        sortParam: {sortOrder:'',sortField:'',sort_real_type:''},
        //排序方式
        frontendSort: false,
        //第一次设置数据
        firstSetData: true,
        //催办id
        urge_record_id:'',
        //定制列数据
        customColumnsFields: [{name:'序号',field:'number',canhide:false,candrag:false,canFix:false}, {name:'操作',field:'myOperate',canhide:true,candrag:true,canFix:true}]
    },
    actions: {
        //创建表头
        createColumnDefs: function () {
            let cols = '';
            // if( this.data.pageType == 5 || this.data.pageType == 7 || this.data.pageType == 2){
            cols = wchService.getWorkflowHeader( this.data.pageType );
            // }else{
            // 	cols = wchService.getWorkflowHeader( this.data.pageType );
            // }
            let number = dgcService.numberCol;
            // number['headerCellTemplate'] = this.actions.resetPreference();
            this.data.columnDefs = [number];
            if( this.data.pageType == 2||this.data.pageType == 0|| this.data.pageType == 5|| this.data.pageType == 7 || this.data.tableId == 'my-sponsor' || this.data.pageType == 9){
                this.data.columnDefs.push( dgcService.selectCol );
                this.data.customColumnsFields.push( {name:'选择',field:'mySelectAll',canhide:false,candrag:false,canFix:false} )
            }
            let fixArr = this.data.fixCols.l.concat(this.data.fixCols.r);
            for( let col of cols ){
                if( col.field == 'myOperate' ){
                    col['suppressFilter'] = true;
                    this.data.columnDefs.push( col );
                    continue;
                }
                let s = this.actions.searchType(col["field"],col.headerName);
                let minWidth = {
                    datetime: 160,
                    time: 90,
                    date: 110
                };
                let obj = {
                    headerName: col.headerName,
                    field: col["field"],
                    enableCellChangeFlash: true,
                    suppressMenu: true,
                    suppressToolPanel: true,
                    // suppressMovable: fixArr.indexOf(data.data["field"]) == -1 ? false : true,
                    colId: col["field"],
                    tooltipField: col["field"],
                    sortingOrder: ['desc', 'asc', null],
                    hide: false,
                    minWidth: minWidth[s.type] || 20,
                    width: col["width"] || 120,
                    cellStyle: {'font-style': 'normal'},
                    floatingFilterComponent: this.floatingFilterCom.actions.createFilter(s.type , s.field, this.data.searchValue, this.data.searchOldValue),
                    floatingFilterComponentParams: {suppressFilterButton: true},
                    enableRowGroup: true,
                    suppressSorting: false,
                    sortField: col["field"],
                    suppressResize: false,
                    suppressMovable: false
                };
                //定制列数据
                this.data.customColumnsFields.push( {name:col.headerName,field:col["field"],canhide:true,candrag:true,canFix:true} );
                this.data.columnDefs.push( obj );
            }
            this.data.fieldsData = this.data.columnDefs;
        },
        resetPreference: function () {
            let ediv = document.createElement('div');
            let eHeader = document.createElement('span');
            let eImg = document.createElement('i');
            eImg.className = 'icon-aggrid icon-aggrid-cancel resetFloatingFilter';
            eImg.title = '重置筛选';
            eImg.addEventListener( 'click',()=>{
                msgBox.confirm( '确定清空筛选数据？' ).then( r=>{
                    if( r ){
                        for( let k in this.data.searchValue ){
                            this.data.searchValue[k] = '';
                        }
                        for( let k in this.data.searchOldValue ){
                            this.data.searchOldValue[k] = '';
                        }
                        this.data.queryList = {};
                        this.actions.setFloatingFilterInput();
                        this.data.filterParam.filter = [];
                        this.actions.getData();
                    }
                } )
            } );
            ediv.appendChild( eHeader );
            eHeader.innerHTML = "初";
            eHeader.className = "table-init-logo";
            eHeader.title = '初始化偏好';
            eHeader.addEventListener('click', () => {
                msgBox.confirm( '确定初始化偏好？' ).then( r=>{
                    if( r ){
                        dataTableService.delPreference( {table_id: this.data.tableId} ).then( res=>{
                            msgBox.showTips( '操作成功' );
                            let obj = {
                                actions: JSON.stringify(['ignoreFields', 'group', 'fieldsOrder', 'pageSize', 'colWidth', 'pinned']),
                                table_id: this.data.tableId
                            };
                            dataTableService.getPreferences( obj ).then( res=>{
                                dgcService.setPreference( res,this.data );
                                //创建表头
                                this.agGrid.gridOptions.api.setColumnDefs( this.data.columnDefs );
                                dgcService.calcColumnState(this.data,this.agGrid,["number","mySelectAll"]);
                                this.customColumnsCom.actions.makeSameSate();
                            } );
                            HTTP.flush();
                        } );
                        HTTP.flush();
                    }
                } )
            });
            ediv.appendChild( eImg );
            return ediv;
        },
        //返回搜索类型
        searchType: function ( data,name ) {
            let type = 'none';
            if( this.data.iCanSearch[data] ){
                type = 'text';
                if( name.indexOf( '时间' ) != -1 ){
                    type = 'datetime';
                }
            }
            return {type:type,field:this.data.iCanSearch[data] || data};
        },
        //渲染
        renderGrid: function () {
            let gridData = {
                columnDefs: this.data.columnDefs,
                noFooter: true,
                // rowData: this.data.rowData,
                footerData: this.data.footerData,
                fieldsData: this.data.fieldsData,
                floatingFilter: true,
                setRowStyle: this.actions.setRowStyle,
                onColumnResized: this.actions.onColumnResized,
                onSortChanged: this.actions.onSortChanged,
                onDragStopped: this.actions.onDragStopped,
                onCellClicked: this.actions.onCellClicked,
                onRowDoubleClicked: this.actions.onRowDoubleClicked
            };
            this.agGrid = new agGrid({data:gridData});
            this.append(this.agGrid , this.el.find('#workflow-agGrid'));
            dgcService.calcColumnState( this.data,this.agGrid,["number","mySelectAll"] );
            if(this.data.tableId == 'approved-workflow'){
                this.agGrid.gridOptions.api.sizeColumnsToFit();
            }

            //渲染分页
            let paginationData = {
                total: this.data.total,
                rows: this.data.rows,
                tableId: this.data.tableId,
                type: 'workflow'
            };
            //渲染分页
            this.pagination = new dataPagination({data: paginationData});
            this.pagination.actions.paginationChanged = this.actions.refreshData;
            this.append(this.pagination, this.el.find('.pagination'));

            let custom = {
                gridoptions: this.agGrid.gridOptions,
                fields: this.data.customColumnsFields,
                fixCols: this.data.fixCols,
                tableId: this.data.tableId,
                agGrid: this.agGrid,
                close: this.actions.calcCustomColumn,
                setFloatingFilterInput: this.actions.setFloatingFilterInput
            };
            //渲染定制列
            if( $('.custom-column-btn')[0] ){
                this.customColumnsCom  = new customColumns({data:custom});
                this.append(this.customColumnsCom, this.el.find('.custom-columns-panel'));
            }
            this.data.firstRender = false;
            //点击关掉定制列panel
            this.el.find( '.ag-body' ).on( 'click',()=>{
                setTimeout( ()=>{
                    this.el.find( '.custom-columns-panel' ).eq(0).animate( { 'right':'-200px' } );
                },400 );
                this.data.isShowCustomPanel = false;
                this.actions.changeAgGridWidth(true);
            } )
        },
        //渲染颜色
        setRowStyle: function (param) {
            if (param.data.wf_urgency_level == 2) {
                return {background: '#FFB5C5'};
            } else if (param.data.wf_urgency_level == 1) {
                return {background: '#FCF5A5'};
            }
        },
        //返回选择数据
        retureSelectData: function () {
            this.data.selectRows = [];
            let rows = this.agGrid.gridOptions.api.getSelectedRows();
            for( let r of rows ){
                if( r._id ){
                    this.data.selectRows.push( r._id );
                }
            }
        },
        //分页刷新
        refreshData: function (res) {
            this.data.rows = res.rows;
            this.data.page = res.currentPage;
            this.data.first = res.first;
            this.actions.getData(true);
        },
        //渲染按钮
        renderBtn: function () {
            if( this.data.tableId == 'my-workflow' || this.data.tableId == 'approving-workflow' || this.data.tableId=='my-sponsor'){
                this.el.find( '.batch-cancel' )[0].style.display = 'flex';
                this.el.find( '.batch-cancel' ).on( 'click',()=>{
                    this.data.selectRows = [];
                    let rows = this.agGrid.gridOptions.api.getSelectedRows();
                    for( let r of rows ){
                        this.data.selectRows.push( r.id );
                    }
                    let noDel =false
                    if(this.data.tableId=='my-sponsor'){
                        rows.forEach((item, index) => {
                            if(this.data.selectRows[index] === item.id  && item.record_status === 1)  {
                                noDel = true
                            }
                        })
                    }
                    if( this.data.selectRows.length == 0 ){
                        msgBox.alert( '请选择要取消的数据！' )
                    }else if( noDel){
                        msgBox.alert('您选的数据包含已完成的状态，不支持取消，请确认');
                    }
                    else {
                        msgBox.confirm( '确定取消？' ).then( res=>{
                            if( res ){
                                let json = {
                                    checkIds: JSON.stringify(this.data.selectRows),
                                    action:4,
                                    type:1
                                };
                                workflowService.approveMany( json )
                                    .then(data => {
                                        if( data.success ){
                                            msgBox.showTips( '取消成功' );
                                            this.actions.getData();
                                        }else {
                                            msgBox.alert( '取消失败：' + data.error );
                                        }
                                    })
                            }
                        } )
                    }
                } );
            }else {
                this.el.find( '.batch-cancel' )[0].style.display = 'none';
            }
            if (this.data.permission.批量审批) {
                if (this.data.tableId == 'approve-workflow' || this.data.tableId == 'suspend-workflow') {
                    this.el.find('.batch-approv')[0].style.display = 'flex';
                    this.el.find('.batch-approv').on('click',() => {
                        let obj = {};
                        let rows = this.agGrid.gridOptions.api.getSelectedRows();
                        obj.appovArray = [];
                        obj.type = 1;
                        obj.appovArray = rows.map((item) =>{
                            return item.id;
                        });
                        if (obj.appovArray.length == 0 ){
                            msgBox.alert('请选择至少一条“待审批”消息进行审批');
                            return ;
                        }
                        PMAPI.openDialogByIframe('/iframe/multiapp/',{
                            width: 540,
                            height: 410,
                            title: '批量审批',
                            // customSize:true
                        },JSON.stringify(obj)).then( res =>{
                            this.data.rowData = this.data.rowData.filter(item => { return  !res.obj.appovArray.includes(item.id) } );
                            this.agGrid.actions.setGridData({
                                rowData: this.data.rowData
                            });
                            this.pagination.actions.setPagination(this.data.rowData.length, this.data.page);
                            workflowService.approveManyWorkflow(res.funcParam)
                            // if (res.refresh){
                            //     this.actions.timeDelayRefresh();
                            // }
                        });
                    });
                } else {
                    this.el.find('.batch-approv')[0].style.display = 'none';
                }
            } else {
                this.el.find('.batch-approv')[0].style.display = 'none';
            }
            //floatingFilter
            let floatSearch = this.el.find( '.float-search-btn' );
            if( floatSearch[0] ){
                floatSearch.on( 'click',()=>{
                    if (this.data.isShowFloatingFilter && this.data.filterParam.filter.length != 0) {
                        for( let k in this.data.searchValue ){
                            this.data.searchValue[k] = '';
                        }
                        for( let k in this.data.searchOldValue ){
                            this.data.searchOldValue[k] = '';
                        }
                        this.data.queryList = {};
                        this.actions.setFloatingFilterInput();
                        this.data.filterParam.filter = [];
                        this.actions.getData();
                    }
                    let height = this.data.isShowFloatingFilter ? 0:30;
                    this.agGrid.gridOptions.api.setFloatingFiltersHeight(height);
                    this.data.isShowFloatingFilter = !this.data.isShowFloatingFilter;
                } )
            }
            //定制列
            // let customCol = this.el.find( '.custom-column-btn' );
            // if( customCol[0] ){
            //     customCol.on( 'click',()=>{
            //         this.customColumnsCom.actions.clearSearch();
            //         this.actions.calcCustomColumn();
            //     } )
            // }
            //新窗口显示隐藏
            // if( this.data.isNewWindow ){
            //     this.el.find( '.grid-new-window' )[0].style.display = 'none';
            // }else {
            //     //全屏
            //     if( this.el.find( '.grid-new-window' )[0] ){
            //         let obj = {
            //             tableId: this.data.tableId,
            //             folder_id: this.data.folderId,
            //             tableName: this.data.tableId2Name[this.data.tableId],
            //             isNewWindow: true
            //         };
            //         let url = dgcService.returnIframeUrl( '/iframe/workflowPage/',obj );
            //         this.el.find('.grid-new-window').attr('href', url);
            //     }
            // }
            //高级查询
            // if( this.el.find( '.expert-search-btn' )[0] ){
            //     this.actions.renderExpertSearch();
            // }
            //宽度自适应
            // this.el.find( '.grid-auto-width' ).on( 'click',()=>{
            //     if( !this.data.isAutoWidth ){
            //         // 我的工作  工作审批
            //         this.data.lastGridState = this.agGrid.gridOptions.columnApi.getColumnState();
            //         this.agGrid.actions.autoWidth();
            //         this.data.lastGridState.forEach((item,index)=>{
            //             item.width * 1.2
            //         })
            //         this.agGrid.gridOptions.columnApi.setColumnState( this.data.lastGridState )
            //     }else {
            //         let state = this.agGrid.gridOptions.columnApi.getColumnState();
            //         console.log(state);
            //         for( let s of state ){
            //             for( let ls of this.data.lastGridState ){
            //                 if( s.colId == ls.colId ){
            //                     s.width = ls.width;
            //                     break;
            //                 }
            //             }
            //             // console.log(s.width,'2');
            //         }
            //         this.agGrid.gridOptions.columnApi.setColumnState( state );
            //     }
            //     this.el.find( '.grid-auto-width' ).find( 'span' ).html( !this.data.isAutoWidth?'恢复默认':'自适宽度' );
            //     this.data.isAutoWidth = !this.data.isAutoWidth;
            // } );
            //根据权限隐藏显示按钮
            for(let k in this.data.permission2btn){

                let btnClass = '.' + this.data.permission2btn[k];
                if(btnClass!='.'&&Object.is(this.data.permission[k],0)){
                    this.el.find(btnClass).hide();
                    //常用查询特殊处理
                    if(btnClass == '.expert-search-btn'){
                        this.el.find('.dataGrid-commonQuery').hide();
                    }
                }
            }
        },
        //定制列事件
        calcCustomColumn: function () {
            this.data.isShowCustomPanel = !this.data.isShowCustomPanel;
            let close = false;
            if( this.data.isShowCustomPanel ){
                this.el.find( '.custom-columns-panel' ).eq(0).animate( { 'right':'0px' } );
            }else {
                close = true;
                setTimeout( ()=>{
                    this.el.find( '.custom-columns-panel' ).eq(0).animate( { 'right':'-200px' } );
                },400 )
            }
            this.actions.changeAgGridWidth(close);
        },
        //改变agGrid宽度
        changeAgGridWidth: function (close) {
            let num = 0;
            if( this.data.isShowCustomPanel ){
                num+=200;
            }
            let grid = this.el.find( '#data-agGrid' );
            if( close ){
                grid.width( 'calc(100% - ' + num + 'px)' );
            }else {
                setTimeout( ()=>{
                    grid.width( 'calc(100% - ' + num + 'px)' );
                },400 )
            }
        },
        //渲染高级查询
        renderExpertSearch: function () {
            let _this = this;
            this.el.find( '.dataGrid-commonQuery' )[0].style.display = 'block';
            this.el.find( '.expert-search-btn' ).on( 'click',()=>{
                let d = {
                    tableId: this.data.tableId,
                    fieldsData: this.data.expertSearchFields,
                    commonQuery: this.data.commonQueryData,
                    commonQuerySelectLength:this.el.find('.dataGrid-commonQuery-select li').length
                    // getExpertSearchData:this.actions.getExpertSearchData,
                    // postExpertSearch:this.actions.postExpertSearch,
                    // saveTemporaryCommonQuery:this.actions.saveTemporaryCommonQuery
                };
                PMAPI.openDialogByIframe(`/iframe/expertSearch/`,{
                    width:950,
                    height:600,
                    title:`高级查询`,
                    modal:true
                },{d}).then(res=>{
                    this.data.onlyCloseExpertSearch = res.onlyclose || false;
                    if(res.type == 'temporaryQuery') {
                        if(res.addNameAry.length == 0){
                            // this.actions.getExpertSearchData(res.addNameAry);
                            this.actions.postExpertSearch(res.value,res.id,res.name);
                        }
                        this.el.find('.dataGrid-commonQuery-select').val(res.name);
                        this.el.find('.dataGrid-commonQuery-select span').html(res.name);
                        this.el.find('.dataGrid-commonQuery-select span').attr('title',res.name);
                    }
                    if(res.appendChecked) {
                        this.data.temporaryCommonQuery = res.value;
                        this.actions.appendQuerySelect()
                    }
                    if(res.saveCommonQuery || res.deleteCommonQuery) {
                        this.actions.getExpertSearchData(res.addNameAry);
                    }
                    if(res.onlyclose == true) {
                        this.actions.getExpertSearchData()
                    }
                    // if(res.saveCommonQuery || (res.saveCommonQuery && res.onlyclose == true)) {
                    //     this.actions.getExpertSearchData(res.addNameAry);
                    // }if(res.deleteCommonQuery || (res.deleteCommonQuery && res.onlyclose == true)) {
                    //     this.actions.getExpertSearchData(res.addNameAry);
                    // } if(!res.saveCommonQuery && res.onlyclose == true) {
                    //     return false
                    // }
                })
            } )
			_this.el.bind('click', function() {
				$(this).find('.dataGrid-commonQuery-ul').hide();
			});
			_this.el.find('.dataGrid-commonQuery-ul').bind('mouseenter', function() {
				$(this).find('li').addClass('remove')
			});
			_this.el.find('.dataGrid-commonQuery-ul').bind('mousemove', function($event) {
				if(!$($event.target).hasClass('active')){
					$($event.target).siblings().removeClass('active')
					$($event.target).addClass('active')
				}
			});
			_this.el.find('.dataGrid-commonQuery-ul').bind('click', function($event) {
				$($event.target).parent().parent().val($($event.target).html())
				$($event.target).parent().parent().find('span').html($($event.target).html())
				if($($event.target).html() == '常用查询') {
					_this.actions.postExpertSearch([],'');
					_this.el.find('.query-tips').css('display','none');
				} else if($($event.target).html() == '临时高级查询') {
					_this.actions.postExpertSearch(_this.data.temporaryCommonQuery,'临时高级查询','临时高级查询');
				} else {
					// $(this).find('.Temporary').remove();
					_this.data.commonQueryData.forEach((item) => {
						if(item.name == $($event.target).html()){
							_this.actions.postExpertSearch(JSON.parse(item.queryParams),item.id,item.name);
						}
					})
				}
			});
			_this.el.find('.dataGrid-commonQuery-select').bind('click', function($event) {
				$event.stopPropagation();
				if($(this).find('.dataGrid-commonQuery-ul').is(':visible')){
					$(this).find('.dataGrid-commonQuery-ul').hide();
				}else{
					$(this).find('.dataGrid-commonQuery-ul').show();
				}
			});
            // _this.el.find('.dataGrid-commonQuery-select').bind('change', function() {
            //     if($(this).val() == '常用查询') {
            //         _this.actions.postExpertSearch([],'');
            //         _this.el.find('.query-tips').css('display','none');
            //     } else if($(this).val() == '临时高级查询') {
            //         _this.actions.postExpertSearch(_this.data.temporaryCommonQuery,'临时高级查询','临时高级查询');
            //     } else {
            //         // $(this).find('.Temporary').remove();
            //         _this.data.commonQueryData.forEach((item) => {
            //             if(item.name == $(this).val()){
            //                 _this.actions.postExpertSearch(JSON.parse(item.queryParams),item.id,item.name);
            //             }
            //         })
            //     }
            // })
            this.actions.getExpertSearchData();
        },
        //获取数据
        getData: async function (refresh) {
            let obj1 = {
                actions: JSON.stringify(['ignoreFields', 'fieldsOrder', 'pageSize', 'colWidth', 'pinned']),
                table_id: this.data.tableId
            };
            if( this.data.firstRender ){
                let preferenceDataIm = await dataTableService.getPreferencesIm(obj1);
                // console.log(preferenceDataIm,'preferenceDataIm')
                let pg=preferenceDataIm.pageSize;
                if( pg && pg.pageSize){
                    this.data.rows=pg.pageSize;
                }
            }
            let json = this.actions.createPostData();
            let gridData = dataTableService.getWorkflowData( json );
            let arr = [gridData];
            if( this.data.firstRender ){
                let preferenceData = dataTableService.getPreferences(obj1);
                let permissionData = dataTableService.getBtnPerm({id:this.data.folderId});
                arr = [gridData,preferenceData,permissionData];
            }
            Promise.all(arr).then((res)=> {
                this.data.rowData = res[0].rows;
                if(this.data.tableId == 'my-sponsor'){
                    for(let i in this.data.rowData) {
                        this.data.rowData[i]['is_sponsor'] = true;
                    }
                }
                this.data.total = res[0].total;
                if( this.data.firstRender ){
                    this.data.permission = res[2]['permission'];
                    wchService.permission = res[2]['permission'];
                    this.data.iCanSearch = res[0].field_mapping;
                    this.actions.renderBtn();
                    this.actions.createColumnDefs();
                    for( let c of this.data.columnDefs ){
                        let f = c.field;
                        let n = c.headerName;
                        if( this.data.iCanSearch[f] ){
                            let obj = {};
                            obj['name'] = n;
                            obj['searchField'] = this.data.iCanSearch[f];
                            obj['searchType'] = n.indexOf( '时间' ) != -1 ? 'datetime':'text';
                            this.data.expertSearchFields.push( obj );
                        }
                    }
                    dgcService.setPreference( res[1],this.data );
                    if (res[1]['fieldsOrder']&&this.data.orderFields.indexOf('myOperate')==-1) {
                        this.data.orderFields.push('myOperate')
                    }
                    this.actions.renderGrid();
                }
                let obj = {
                    rowData: this.data.rowData
                };
                this.actions.sortWay();
                setTimeout(()=>{
                    this.agGrid.actions.setGridData( obj );
                    this.actions.bindScrollTimer();
                },500)
                this.pagination.actions.setPagination( this.data.total,this.data.page );
                //第一次关闭loading
                if( this.data.firstSetData ){
                    this.hideLoading();
                    this.data.firstSetData = false;
                }
                if(refresh){
                    msgBox.showTips( '数据刷新成功。' )
                }
            });
            HTTP.flush();
        },
        //设置搜索input值
        setFloatingFilterInput: function () {
            for( let k in this.data.searchValue ){
                if(this.el.find( '.filter-input-'+k )[0]){
                    this.el.find( '.filter-input-'+k )[0].value = this.data.searchValue[k];
                }
            }
        },
        //绑定scroll事件监听虚拟dom渲染
        bindScrollTimer(){
                this.el.find('.ag-body-viewport').on('scroll',(event)=>{
                    if(this.data.scrollTimer){
                        clearTimeout(this.data.scrollTimer);
                    }
                    this.data.scrollTimer=null;
                    this.data.scrollTimer=setTimeout(()=>{
                        this.actions.setFloatingFilterInput();
                    },100)
                })
        },
        //创建请求数据参数
        createPostData: function () {
            let json = {
                type:this.data.pageType,rows:this.data.rows,page:this.data.page,filter:[]
            };
            if( this.data.filterParam.filter && this.data.filterParam.filter.length != 0 ){
                json['filter'] = _.cloneDeep(this.data.filterParam.filter ) || []
            }
            if( this.data.filterParam['common_filter_id'] ){
                json['filter'] = json['filter'] || [];
                //这个顺序要保证是先高级查询，再搜索的
                let len = this.data.filterParam.expertFilter.length - 1;
                for(let i = len; i>=0; i--){
                    json['filter'].unshift(this.data.filterParam.expertFilter[i]);
                }
                // for( let a of this.data.filterParam.expertFilter ){
                //     json['filter'].push( a );
                // }
                if( this.data.filterParam['common_filter_id'] != '临时高级查询' ){
                    json['common_filter_id'] = this.data.filterParam['common_filter_id'] || '';
                }
                if( this.data.filterParam.filter.length == 0 ){
                    let dom = `<div class='query-tips'><span class="query-tips-delete"></span><span class="title">加载常用查询&lt;<span class="text">${this.data.filterParam['common_filter_name']}</span>&gt;</span></div>`;
                    this.el.find('.btn-nav').append(dom);
                    setTimeout(()=>{
                        this.el.find('.query-tips').css('display','none');
                    },3000);
                    this.el.find('.query-tips-delete').on('click', ()=> {
                        this.el.find('.query-tips').css('display','none');
                    })
                    // msgBox.alert( '加载常用查询<'+this.data.filterParam['common_filter_name']+'>' );
                }
            }
            //排序
            if( this.data.sortParam.sortField ){
                // json = _.defaultsDeep( json,this.data.sortParam )
                for(let k in this.data.sortParam){
                    json[k] = this.data.sortParam[k];
                }
            }
            json = dgcService.returnQueryParams( json );
            if( json.filter && json.filter != '' ){
                if( this.data.filterText != json.filter ){
                    this.data.first = 0;
                    json.page = 1;
                    this.data.page = 1;
                    this.data.filterText = json.filter;
                }
            }
            return json;
        },
        //设置常用查询选项值
        appendQuerySelect: function() {
            let length = this.el.find('.dataGrid-commonQuery-select li').length
            for (let i = 0; i< length ;i++) {
                if(this.el.find('.dataGrid-commonQuery-select li').eq(i).html() == '临时高级查询'){
                    this.el.find('.dataGrid-commonQuery-select li').eq(i).remove()
                }
            }
            this.el.find('.dataGrid-commonQuery-ul').append(`<li class="dataGrid-commonQuery-option Temporary" fieldId="00" value="临时高级查询">临时高级查询</li>`)
            this.el.find('.dataGrid-commonQuery-select').val('临时高级查询');
            this.el.find('.dataGrid-commonQuery-select span').html('临时高级查询');
            this.el.find('.dataGrid-commonQuery-select span').attr('title','临时高级查询');

        },
        //获取高级查询数据
        getExpertSearchData: function (addNameAry) {
            let obj = {'actions':JSON.stringify( ['queryParams'] ),'table_id':this.data.tableId};
            dataTableService.getPreferences( obj ).then( res=>{
                this.el.find('.dataGrid-commonQuery-option').remove();
                this.el.find('.dataGrid-commonQuery-ul').append(`<li class="dataGrid-commonQuery-option" fieldId="100" value="常用查询">常用查询</li>`)
                if(res.rows.length != 0){
                    res.rows.forEach((row) => {
                        this.el.find('.dataGrid-commonQuery-ul').append(`<li class="dataGrid-commonQuery-option" fieldId="${row.id}" value="${row.name}">${row.name}</li>`)
                    });
                }
                if(this.data.filterParam['common_filter_name'] && this.data.onlyCloseExpertSearch) {
                    this.el.find('.dataGrid-commonQuery-select').val(this.data.filterParam['common_filter_name']);
                    this.el.find('.dataGrid-commonQuery-select span').html(this.data.filterParam['common_filter_name']);
                    this.el.find('.dataGrid-commonQuery-select span').attr('title',this.data.filterParam['common_filter_name']);
                }
                if(this.data.commonQueryData && res.rows && this.data.commonQueryData.length > res.rows.length){
                    let inCheck = true;
                    if(this.data.filterParam['common_filter_name'] != ''){
                        if(res.rows.length == 0){
                            inCheck = true;
                        } else {
                            for(let item of res.rows) {
                                if (item.name == this.data.filterParam['common_filter_name']) {
                                    inCheck = false ;
                                }
                            }
                        }
                    }
                    if(inCheck) {
                        this.actions.postExpertSearch([],'');
                        this.el.find('.dataGrid-commonQuery-select').val('常用查询');
                        this.el.find('.dataGrid-commonQuery-select span').html('常用查询');
                        this.el.find('.dataGrid-commonQuery-select span').attr('title','常用查询');
                    }
                }
                this.data.commonQueryData = res.rows;
                if(addNameAry && addNameAry.length != 0){
                    this.data.commonQueryData.forEach((item)=>{
                        for(let i = 0; i < addNameAry.length; i++) {
                            if(item.name == addNameAry[i]){
                                this.actions.postExpertSearch(JSON.parse(item.queryParams),item.id,item.name);
                                this.el.find('.dataGrid-commonQuery-select').val(item.name);
                                this.el.find('.dataGrid-commonQuery-select span').html(item.name);
                                this.el.find('.dataGrid-commonQuery-select span').attr('title',item.name);
                            }
                        }
                    })
                }
            } );
            HTTP.flush();
        },
        postExpertSearch:function(data,id,name) {
            this.data.filterParam.expertFilter = data;
            this.data.filterParam.common_filter_id = id;
            this.data.filterParam.common_filter_name = name;
            this.actions.getData();
        },
        //floatingFilter
        floatingFilterPostData: function (col_field, keyWord, searchOperate) {

        },
        onColumnResized: function ($event) {
            this.customColumnsCom.actions.onColumnResized( this.customColumnsCom );
        },
        onDragStopped: function ($event) {
            this.customColumnsCom.actions.onFix();
            this.customColumnsCom.actions.dragAction();
        },
        onSortChanged: function ($event) {
            if( this.data.frontendSort ){
                this.agGrid.actions.refreshView();
                return;
            }
            let data = this.agGrid.gridOptions.api.getSortModel()[0];
            if (data) {
                this.data.sortParam['sortOrder']= (data.sort == "desc" ? -1 : 1);
                this.data.sortParam['sortField']=data.colId;
            }else {
                this.data.sortParam = {sortOrder:'',sortField:'',sort_real_type:''}
            }
            this.actions.getData();
        },
        onRowDoubleClicked: function ($event) {
            let obj = {
                form_id: $event["data"]["form_id"],
                record_id: $event["data"]["id"],
                flow_id: $event["data"]["flow_id"],
                table_id: $event["data"]["table_id"]
            };
            let winTitle = '查看工作';
            obj['btnType'] = 'view';
            if(this.data.tableId=="approve-workflow"){
                obj['btnType'] = 'edit';
                winTitle='审批工作';
            }
            if($event["data"]["status"] == '已完成' && this.data.pageType == 8) {
                obj['circulation'] = true;
            }
            //中信信托项目管理新增
            if($event['data']['table_id'] == '9364_MHTHP6HEiftxQyrbeQwm78'){
                let theModel = reactDialog;
                theModel.show({
                    title: '项目管理',
                    el: ProjectManager,
                    isEdit: false,
                    record_id: $event["data"]["id"],
                    flow_id: $event["data"]["flow_id"],
                    showRecord: true,
                    isFrom: 'workflow',
                    event: {
                        closeDialog() {
                            theModel.hide();
                        }
                    }
                })
                return;
            }
            //投资顾问流程
            if($event['data']['table_id'] == '3758_gZzndkxkm8ndk6FBcQymy4'){
                let theModel = reactDialog;
                theModel.show({
                    title: '投资顾问',
                    el: InvestmentAdvisor,
                    isEdit: false,
                    record_id: $event["data"]["id"],
                    flow_id: $event["data"]["flow_id"],
                    showRecord: true,
                    isFrom: 'workflow',
                    event: {
                        closeDialog() {
                            theModel.hide();
                        }
                    }
                    
                })
                return;
            }
            let url = dgcService.returnIframeUrl( '/wf/approval/',obj );
            this.actions.openSourceDataGrid( url,winTitle );
        },
        onCellClicked: function ($event) {
            let type = $event["event"]["target"]["dataset"]["type"];
            let obj = {
                form_id: $event["data"]["form_id"],
                record_id: $event["data"]["id"],
                flow_id: $event["data"]["flow_id"],
                table_id: $event["data"]["table_id"]
            };
            let winTitle = '';
            if( this.data.pageType == 0 || this.data.pageType == 1 ){
                if(type === 'view'){
                    winTitle = '查看工作';
                    //中信信托项目管理新增
                    if($event['data']['table_id'] == '9364_MHTHP6HEiftxQyrbeQwm78'){
                        let theModel = reactDialog;
                        theModel.show({
                            title: '项目管理',
                            el: ProjectManager,
                            isEdit: false,
                            record_id: $event["data"]["id"],
                            flow_id: $event["data"]["flow_id"],
                            showRecord: true,
                            isFrom: 'workflow',
                            event: {
                                closeDialog() {
                                    theModel.hide();
                                }
                            }
                        })
                        return;
                    }
                    //投资顾问流程
                    if($event['data']['table_id'] == '3758_gZzndkxkm8ndk6FBcQymy4'){
                        let theModel = reactDialog;
                        theModel.show({
                            title: '投资顾问',
                            el: InvestmentAdvisor,
                            isEdit: false,
                            record_id: $event["data"]["id"],
                            flow_id: $event["data"]["flow_id"],
                            showRecord: true,
                            isFrom: 'workflow',
                            event: {
                                closeDialog() {
                                    theModel.hide();
                                }
                            }
                        })
                        return;
                    }

                    obj['btnType'] = 'view';
                    let url = dgcService.returnIframeUrl( '/wf/approval/',obj );
                    this.actions.openSourceDataGrid( url,winTitle );
                }else if( type === 'cancel'){
                    if(Object.is(this.data.permission.cancel,0)){
                        msgBox.alert('没有取消工作权限。');
                        return;
                    }
                    this.actions.approveWorkflow( $event["data"]["id"],4,'确定取消？' )
                }
            }
            if( this.data.pageType == 2||this.data.pageType == 3||this.data.pageType == 4||this.data.pageType == 6 || this.data.pageType == 8 ||  this.data.pageType == 9){
                if(type === 'view'){
                    if($event["data"]["status"] == '已完成' && this.data.pageType == 8) {
                        obj['circulation'] = true;
                    }
                    //中信信托项目管理新增
                    if($event['data']['table_id'] == '9364_MHTHP6HEiftxQyrbeQwm78'){
                        let theModel = reactDialog;
                        theModel.show({
                            title: '项目管理',
                            el: ProjectManager,
                            isEdit: false,
                            record_id: $event["data"]["id"],
                            flow_id: $event["data"]["flow_id"],
                            showRecord: true,
                            isFrom: 'workflow',
                            event: {
                                closeDialog() {
                                    theModel.hide();
                                }
                            }
                        })
                        return;
                    }
                    //投资顾问流程
                    if($event['data']['table_id'] == '3758_gZzndkxkm8ndk6FBcQymy4'){
                        let theModel = reactDialog;
                        theModel.show({
                            title: '投资顾问',
                            el: InvestmentAdvisor,
                            isEdit: false,
                            record_id: $event["data"]["id"],
                            flow_id: $event["data"]["flow_id"],
                            showRecord: true,
                            isFrom: 'workflow',
                            event: {
                                closeDialog() {
                                    theModel.hide();
                                }
                            }
                        })
                        return;
                    }
                    winTitle = '查看工作';
                    obj['btnType'] = 'view';
                    let url = dgcService.returnIframeUrl( '/wf/approval/',obj );
                    this.actions.openSourceDataGrid( url,winTitle );
                }else if(type === 'cancel'){
                    if(Object.is(this.data.permission.cancel,0)){
                        msgBox.alert('没有取消工作权限。');
                        return;
                    }
                    if(this.data.pageType == 2){
                        this.actions.approveWorkflow( $event["data"]["id"],4,'确定删除？' )
                    }else{
                        this.actions.approveWorkflow( $event["data"]["id"],4,'确定取消？' )
                    }
                }else if(type === 'withdraw'){
                    if($event.data['record_status'] === 4) {
                        msgBox.alert('该流程已被审批人暂缓，目前不支持流程催办/流程撤回');
                        return
                    }
                    this.actions.approveWorkflow( $event["data"]["id"],5,'确定撤回？' )
                }else if(type === 'edit'){
                    if($event["data"]["status"] == '已撤回' ) {
                        obj['recall'] = 1;
                    }
                    //中信信托项目管理新增
                    if($event['data']['table_id'] == '9364_MHTHP6HEiftxQyrbeQwm78'){
                        let theModel = reactDialog;
                        theModel.show({
                            title: '项目管理',
                            el: ProjectManager,
                            isEdit: true,
                            record_id: $event["data"]["id"],
                            flow_id: $event["data"]["flow_id"],
                            showRecord: true,
                            // isFrom: 'workflow',
                            event: {
                                closeDialog() {
                                    theModel.hide();
                                }
                            }
                        })
                        return;
                    }
                    //投资顾问流程
                    if($event['data']['table_id'] == '3758_gZzndkxkm8ndk6FBcQymy4'){
                        let theModel = reactDialog;
                        theModel.show({
                            title: '投资顾问',
                            el: InvestmentAdvisor,
                            isEdit: true,
                            record_id: $event["data"]["id"],
                            flow_id: $event["data"]["flow_id"],
                            showRecord: true,
                            // isFrom: 'workflow',
                            event: {
                                closeDialog() {
                                    theModel.hide();
                                }
                            }
                        })
                        return;
                    }
                    winTitle = '编辑工作';
                    obj['btnType'] = 'edit';
                    let url = dgcService.returnIframeUrl( '/wf/approval/',obj );
                    this.actions.openSourceDataGrid( url,winTitle );
                }else if(type === 'drawApproval'){
                    this.actions.approveWorkflow( $event["data"]["id"],7,'确定撤回？' )
                }else if( type === 'focusWorkflow' ){
                    //中信信托项目管理新增
                    if($event['data']['table_id'] == '9364_MHTHP6HEiftxQyrbeQwm78'){
                        let theModel = reactDialog;
                        theModel.show({
                            title: '项目管理',
                            el: ProjectManager,
                            isEdit: false,
                            record_id: $event["data"]["id"],
                            flow_id: $event["data"]["flow_id"],
                            showRecord: true,
                            isFrom: 'workflow',
                            event: {
                                closeDialog() {
                                    theModel.hide();
                                }
                            }
                        })
                        return;
                    }
                    //投资顾问流程
                    if($event['data']['table_id'] == '3758_gZzndkxkm8ndk6FBcQymy4'){
                        let theModel = reactDialog;
                        theModel.show({
                            title: '投资顾问',
                            el: InvestmentAdvisor,
                            isEdit: false,
                            record_id: $event["data"]["id"],
                            flow_id: $event["data"]["flow_id"],
                            showRecord: true,
                            isFrom: 'workflow',
                            event: {
                                closeDialog() {
                                    theModel.hide();
                                }
                            }
                        })
                        return;
                    }
                    winTitle = '查看工作';
                    obj['btnType'] = 'view';
                    let url = dgcService.returnIframeUrl( '/wf/approval/',obj );
                    this.actions.openSourceDataGrid( url,winTitle );
                }else if(type === 'urge'){
                    if($event.data['record_status'] === 4) {
                        msgBox.alert('该流程已被审批人暂缓，目前不支持流程催办/流程撤回');
                        return;
                    }
                    this.actions.calcUrge(true);
                    this.data.urge_record_id = $event["data"]["id"];
                }else if(type === 'circulation') {
                    this.actions.openAddFollower($event);
                }
            }
            if( this.data.pageType == 5 || this.data.pageType == 7 ){
                let isEdit = false;
                if(type === 'approve'){
                    winTitle = '审批工作';
                    obj['btnType'] = 'edit';
                    isEdit = true;
                }else if(type === 'view'){
                    winTitle = '查看工作';
                    obj['btnType'] = 'view';
                }else if(type === 'suspend'){
                    this.actions.setWorkflowType( obj );
                    return false;
                }else{
                    return false;
                }
                //中信信托项目管理新增
                if($event['data']['table_id'] == '9364_MHTHP6HEiftxQyrbeQwm78'){
                    let theModel = reactDialog;
                    theModel.show({
                        title: '项目管理',
                        el: ProjectManager,
                        isEdit: isEdit,
                        record_id: $event["data"]["id"],
                        showRecord: true,
                        type: type,
                        flow_id: $event["data"]["flow_id"],
                        isFrom: 'workflow',
                        event: {
                            closeDialog() {
                                theModel.hide();
                                this.actions.getData();
                            }
                        }
                    })
                    return;
                }
                //投资顾问流程
                if($event['data']['table_id'] == '3758_gZzndkxkm8ndk6FBcQymy4'){
                    let _that = this;
                    let theModel = reactDialog;
                    theModel.show({
                        title: '投资顾问',
                        el: InvestmentAdvisor,
                        isEdit: isEdit,
                        record_id: $event["data"]["id"],
                        showRecord: true,
                        type: type,
                        flow_id: $event["data"]["flow_id"],
                        isFrom: 'workflow',
                        event: {
                            closeDialog() {
                                theModel.hide();
                                _that.actions.getData()
                            }
                        }
                    })
                    return;
                }
                let url = dgcService.returnIframeUrl( '/wf/approval/',obj );
                this.actions.openSourceDataGrid( url,winTitle );
                if($event.data.wf_urgency_level == 1){
                    msgBox.alert('催办消息：' + ($event.data.urge_info||''));
                }
            }
        },
        //暂缓审批工作
        setWorkflowType:function (obj) {
            let json = {
                record_id:obj.record_id,
                flow_id:obj.flow_id,
                type:7
            }
            workflowService.setWorkflowType(json)
                .then(res=>{
                    if(res.success){
                        msgBox.showTips( '操作成功' );
                        this.actions.timeDelayRefresh();
                    }else{
                        msgBox.alert( '操作失败：' + res.error );
                    }
                })
        },
        // 打开添加传阅人
        openAddFollower($event) {
            let ary = $event.data.circulate_users;
            PMAPI.openDialogByIframe(`/iframe/addfocus/`, {
                width: 800,
                height: 620,
                title: `添加传阅人`,
                modal: true
            },{users:ary}).then(res => {
                if (!res.onlyclose) {
                    let nameArr=[],idArr=[],htmlStr=[];
                    for(let k in res){
                        nameArr.push(res[k]);
                        htmlStr.push(`<span class="selectSpan">${res[k]}</span>`);
                        idArr.push(k);
                        if(!ary.includes(k)) {
                            ary.push(k)
                        }
                    }
                    // $event.data.circulate_users = res;
                    this.actions.postCirculateUser(idArr,$event.data.id);
                }
            })
        },
        // 保存传阅人
        async postCirculateUser(idArr,id) {
            let obj = {
                record_id: id,
                action: 14,
                circulate_users: JSON.stringify(idArr) || [],
                comment: '',
                comment_attachment: '[]',
            }
            let res = await workflowService.approve(obj);
            if (res.success === 1) {
                msgBox.showTips('保存成功');
            } else {
                msgBox.showTips('保存失败');
            }
        },
        //打开关闭催办
        calcUrge: function (show) {
            if(show){
                this.el.find('.urge-con').show();
                this.el.find('.urge').show();
            }else {
                this.el.find('.urge-info').val('');
                this.data.urge_record_id = '';
                this.el.find('.urge-con').hide();
                this.el.find('.urge').hide();
            }
        },
        //保存催办
        saveUrge: function () {
            let json = {
                record_id: this.data.urge_record_id,
                info: this.el.find('.urge-info').val()
            };
            workflowService.urge( json )
                .then(res => {
                    if( res.success ){
                        msgBox.showTips( '操作成功' );
                    }else {
                        msgBox.alert( '操作失败：' + res.error );
                    }
                })
            this.actions.calcUrge(false);
        },
        //设置失效
        setInvalid: function () {
            if( this.pagination ){
                this.pagination.data.myInvalid = true;
            }
        },
        //延时刷新
        timeDelayRefresh: function(){
            this.actions.setInvalid();
            this.pagination.actions.timeDelayRefresh();
        },
        //打开穿透数据弹窗
        openSourceDataGrid: function ( url,title ) {
            let defaultMax = false;
            if( url.indexOf( '/wf/approval/' ) != -1 ){
                defaultMax = true;
            }
            PMAPI.openDialogByIframe( url,{
                width: 1000,
                height: 800,
                title: title,
                modal:true,
                // defaultMax: defaultMax,
                customSize: defaultMax
            } ).then( (data)=>{
                if(title == '审批工作'){
                    this.data.rowData = this.data.rowData.filter(item => { return item.id != data.obj.record_id });
                    let obj = {
                        rowData: this.data.rowData
                    }
                    this.agGrid.actions.setGridData( obj );
                    this.pagination.actions.setPagination( this.data.rowData.length, this.data.page );
                    workflowService.approveWorkflowRecord({
                        url: '/approve_workflow_record/',
                        data: data.funcParam
                    })
                    data.refresh = false;
                }
                if( data.refresh ){
                    this.actions.timeDelayRefresh();
                }
            } )
        },
        //操作工作流
        approveWorkflow: function (id,action,mes) {
            msgBox.confirm( mes ).then((res)=>{
                if(res===true){
                    let json = {
                        record_id: id,
                        action: action
                    };
                    workflowService.approve( json )
                        .then(res => {
                            if( res.success ){
                                msgBox.showTips( '操作成功' );
                                this.actions.timeDelayRefresh();
                            }else {
                                msgBox.alert( '操作失败：' + res.error );
                            }
                        })
                }
            })
        },
        //floatingFilter拼参数
        floatingFilterPostData: function (col_field, keyWord, searchOperate) {
            this.data.queryList[col_field] = {
                'keyWord': keyWord,
                'operate': dgcService.getMongoSearch(searchOperate),
                'col_field': col_field
            };
            //用于去除queryList中的空值''
            let obj = {};
            for (let key in this.data.queryList) {
                if (!( this.data.queryList[key]["keyWord"] == "" )) {
                    obj[key] = this.data.queryList[key];
                }
            }
            this.data.queryList = obj;
            let filter = [];
            for (let attr in this.data.queryList) {
                filter.push({
                    "relation": "$and",
                    "cond": {
                        "leftBracket": 0,
                        "searchBy": this.data.queryList[attr]['col_field'],
                        "operate": this.data.queryList[attr]['operate'],
                        "keyword": this.data.queryList[attr]['keyWord'],
                        "rightBracket": 0
                    }
                });
            }
            this.data.filterParam['filter'] = filter;
            this.data.filterParam['is_filter'] = 1;
            this.actions.getData();
        },
        //排序方式
        sortWay: function () {
            this.data.frontendSort = this.data.total < this.data.rows?true:false;
            console.log( '排序方式：' + (this.data.frontendSort ? '前端排序' : '后端排序') );
            this.agGrid.gridOptions["enableServerSideSorting"] = !this.data.frontendSort;
            this.agGrid.gridOptions["enableSorting"] = this.data.frontendSort;
        },
    },
    binds: [
        {
            event: 'click',
            selector: '.cancel-urge',
            callback: function (context) {
                this.actions.calcUrge(false);
            }
        },
        {
            event: 'click',
            selector: '.close-urge',
            callback: function (context) {
                this.actions.calcUrge(false);
            }
        },
        {
            event: 'click',
            selector: '.submit-urge',
            callback: function (context) {
                this.actions.saveUrge(false);
            }
        },{
            event: 'click',
            selector: '.common-use',
            callback: function (event) {
                let clickLabel = event.getAttribute('title');
                let el = this.el.find('.common-use');
                let tableName = '';
                switch (window.frameElement.id) {
                    case 'my-workflow':
                        tableName = '我的工作';
                        break;
                    case 'finished-workflow':
                        tableName = '已完成的工作';
                        break;
                    case 'approving-workflow':
                        tableName = '进展中的工作';
                        break;
                    case 'approve-workflow':
                        tableName = '工作审批';
                        break;
                }
                PMAPI.sendToParent( {
                    key: this.key,
                    type: PMENUM.save_common,
                    data:{
                        tableId: window.frameElement.id,
                        saveCommon: clickLabel === '存为常用'? true: false,
                        tableName: tableName,
                    }
                });
                if(clickLabel === '存为常用') {
                    el[0].childNodes[1].innerHTML = '取消常用';
                    el[0].title = '取消常用';
                    el[0].childNodes[0].className = 'icon-aggrid icon-aggrid-cancel-common-use';
                } else if(clickLabel === '取消常用') {
                    el[0].childNodes[1].innerHTML = '存为常用';
                    el[0].title = '存为常用';
                    el[0].childNodes[0].className = 'icon-aggrid icon-aggrid-common-use';
                }
            }
        },
    ],
    afterRender: function (){
        this.showLoading();
        this.el.find( '.headerTips' ).eq(0).find( 'span' ).eq(0).html( this.data.tableId2Name[this.data.tableId] );
        this.floatingFilterCom = new FloatingFilter();
        this.floatingFilterCom.actions.floatingFilterPostData = this.actions.floatingFilterPostData;
        console.log(this.data.tableId)
        this.data.pageType = this.data.tableId2pageType[this.data.tableId];
        this.actions.getData();
	    if(localStorage.getItem('commonMenuLabel')&& localStorage.getItem('commonMenuLabel').indexOf(window.frameElement && window.frameElement.id)>=0) {
            let el = this.el.find('.common-use');
            if(el.length) {
                el[0].childNodes[1].innerHTML = '取消常用';
                el[0].title = '取消常用';
                el[0].childNodes[0].className = 'icon-aggrid icon-aggrid-cancel-common-use';
            }
        }
        if(this.data.fromFront){
            console.log('btn', this.el.find('.workflowGrid-btn-group'))
            this.el.find('.showBtn').hide();
        }
    }
});
// class workflowPage extends Component {
//     constructor(data,newConfig){
//         for (let d in data) {
//             config.data[d] = data[d];
//         }
//         super($.extend(true,{},config,newConfig,{data:data||{}}));
//     }
// }

export default workflowPage;


// WEBPACK FOOTER //
// app/components/customPage/workflow-page/workflow-page.js